// viewport.service.ts
import { Injectable, inject } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map, distinctUntilChanged, shareReplay } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ViewportService {
    
    private bp = inject(BreakpointObserver);

    // tweak the set of breakpoints to your needs
    readonly isMobile$: Observable<boolean> = this.bp.observe([
        Breakpoints.XSmall, // ~ < 600px
        Breakpoints.Small,  // ~ 600–960px
    ]).pipe(
        map(state => state.breakpoints[Breakpoints.XSmall] || state.breakpoints[Breakpoints.Small]),
        distinctUntilChanged(),
        shareReplay({ bufferSize: 1, refCount: true })
    );
}
